var _path, _g, _path2, _g2, _path3, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 50,
    viewBox: "0 0 68 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6048_43735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8339 0H0V49.7095H67.8339V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6048_43735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.04893 48.3535L1.91244 47.5102C-0.222798 45.924 -0.632244 42.9297 1.00171 40.8568L13.0746 25.5476C14.7085 23.4746 17.7928 23.0771 19.928 24.6634L21.0645 25.5104C23.1997 27.0967 23.6092 30.0909 21.9752 32.1639L9.90235 47.4731C8.26839 49.546 5.18417 49.9435 3.04893 48.3573",
    fill: "#2D4445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8716 16.0772C12.9571 14.5206 15.9457 14.8958 17.5529 16.9205L37.7572 42.4012C38.9282 43.8797 39.0085 44.5707 37.2942 45.8486L35.5263 47.1712C33.4408 48.7277 30.4523 48.3525 28.8451 46.3279L10.003 22.5635C8.39967 20.5388 8.78616 17.6375 10.8716 16.0772Z",
    fill: "#41B8E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9937 30.022L44.1888 23.8552C43.8444 23.4911 43.8712 22.9265 44.2462 22.5921L51.5358 16.1281C53.5639 14.3264 56.7132 14.4676 58.5691 16.4365L58.8982 16.7894C60.7541 18.7583 60.6125 21.8157 58.5806 23.6174L51.2909 30.0814C50.9159 30.4158 50.3343 30.3897 49.9899 30.0257",
    fill: "#FAC02E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.309 14.7695L42.0885 24.9819L33.1993 36.6542L25.2056 26.4976L34.309 14.7695Z",
    fill: "#EC7426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.702 3.80469L18.4595 18.07L25.2057 26.4992L35.7824 13.0586L29.702 3.80469Z",
    fill: "#FBBD34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5309 45.8847L46.9134 33.592C45.6583 31.6491 46.4543 28.2871 48.4556 27.0723L51.6431 25.1331C53.6444 23.9146 56.3077 24.509 57.5628 26.4519L67.0604 40.7433C68.591 43.1134 67.7683 46.5831 65.327 48.0691C62.0017 50.0937 57.6126 49.113 55.5309 45.8847Z",
    fill: "#2F4546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6048_43735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 30,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4615 0.928733C31.3391 0.995602 31.2243 1.06619 31.1171 1.14791C30.7689 1.40796 30.3442 1.78317 29.95 2.30697C29.9424 2.3144 29.9386 2.32183 29.9309 2.32926C29.2115 3.29514 29.2689 4.61394 30.0342 5.54639C32.7511 8.84897 35.4986 12.4079 38.2308 16.2305C39.6122 18.166 40.9285 20.0792 42.176 21.959C42.792 22.8877 42.7576 24.0876 42.088 24.9792C40.6683 26.8812 39.2295 28.7907 37.7716 30.7039C34.5572 34.9278 31.3429 39.0625 28.1362 43.1155C27.4092 44.0331 27.3748 45.2999 28.0406 46.262C29.5559 48.4427 31.8174 49.6984 33.9488 49.7095H33.9986C34.32 49.7095 34.6376 49.6798 34.9514 49.6166C36.88 49.2488 38.1274 47.7554 38.644 47.0942C41.866 42.9632 47.759 35.7822 55.4274 26.3649C56.1774 25.4399 56.2234 24.1508 55.5384 23.1812C50.7513 16.4237 45.9681 9.66997 41.1811 2.91251C41.1466 2.8605 41.1084 2.8122 41.0701 2.76391C40.63 2.22896 39.0611 0.497801 36.3251 0.0854433C35.9272 0.0260044 35.5407 0 35.1772 0C33.4016 0 32.0508 0.616679 31.4692 0.928733",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6048_43735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3055 -6.99245L14.583 46.3867L54.2931 56.7093L69.0156 3.33016L29.3055 -6.99245Z",
    fill: "url(#paint0_linear_6048_43735)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6048_43735",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8339 0H0V49.7095H67.8339V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6048_43735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3169 33.5898L57.0733 44.066L56.5108 47.1196L47.7671 35.4324L49.3169 33.5898Z",
    fill: "#4DAFE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6048_43735",
    x1: 49.2378,
    y1: -5.84401,
    x2: 29.0119,
    y2: 71.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4042"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.323e9523617fcf3eba20132aae7e6903.svg";
export { ForwardRef as ReactComponent };